import ServiceItemAdvancedSelector from './serviceitem-advanced-selector.vue'

ServiceItemAdvancedSelector.install = function (Vue) {
	Vue.component(ServiceItemAdvancedSelector.name, ServiceItemAdvancedSelector);
}

export default ServiceItemAdvancedSelector;